<template>
    <!-- Record Images -->
    <div class='row' v-if='property.column == "custom_media" && (object.images.length > 0 || object.media.length > 0)'>
        <div class='col-md-2 hidden-print'></div>
        <div class='col-md-3'><strong>{{property.label}}</strong></div>
        <div class='col-md-7'>
            <span class='my_thumbnail clickable' v-for='(m, index) in media'>
                <span @click='viewMedia(index)'>
                    <img :src="m.thumbnail_path" :title='m.title' :alt='m.title'>
                    <meta itemprop='thumbnailUrl' :content="m.thumbnail_path"/>
                </span>
            </span>
        </div>
    </div>
</template>

<script>
    import manageProperties from './../../mixins/manageProperties.js'
    import EventHub from './../eventHub.js'
    import MediaParser from './../../mixins/mediaParser.js'

    export default {
        mixins: [manageProperties, MediaParser],
        props: ['object', 'property'],
        computed: {
            media: function () {
                console.log("object",this.object);
                console.log("parseMedia",this.parseMedia(this.object, 100, 100));
                return this.parseMedia(this.object, 100, 100)
            }

        },
        methods: {
            viewMedia: function (index) {
                EventHub.$emit('view-enlarged', {object: this.object, selected: index})
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/variables.scss';

    .asset, .images {
        margin-right: 10px;
        margin-bottom: 10px;
    }

    .asset {
        width: 100px;
        margin-top: -15px;
    }

    .my_thumbnail {
        img {
            max-width: 100px;
            max-height: 100px;
            padding: 4px;
            border: 1px solid #ddd;
            border-radius: 4px;
            transition: border 0.2s ease-in-out;
            margin-right: 10px;
            margin-bottom: 10px;
        }
    }

    .document {
        height: 100px;
        width: 100px;
        border: 1px solid black;
        color: white;
        background-color: $dark_gray;
        text-align: center;
        vertical-align: middle;
    }
</style>
